/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Created_ToastInputs */

const en_style_guide_manager_created_toast = /** @type {(inputs: Style_Guide_Manager_Created_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New style guide created`)
};

const fr_style_guide_manager_created_toast = /** @type {(inputs: Style_Guide_Manager_Created_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouveau guide de style cree`)
};

const de_style_guide_manager_created_toast = /** @type {(inputs: Style_Guide_Manager_Created_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neuer Styleguide erstellt`)
};

const it_style_guide_manager_created_toast = /** @type {(inputs: Style_Guide_Manager_Created_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuova guida di stile creata`)
};

const ru_style_guide_manager_created_toast = /** @type {(inputs: Style_Guide_Manager_Created_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создан новый стиль оформления.`)
};

const es_style_guide_manager_created_toast = /** @type {(inputs: Style_Guide_Manager_Created_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se creó una nueva guía de estilo`)
};

const zh_cn2_style_guide_manager_created_toast = /** @type {(inputs: Style_Guide_Manager_Created_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新版风格指南已制定`)
};

const ja_style_guide_manager_created_toast = /** @type {(inputs: Style_Guide_Manager_Created_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しいスタイルガイドが作成されました`)
};

const hi_style_guide_manager_created_toast = /** @type {(inputs: Style_Guide_Manager_Created_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नई स्टाइल गाइड बनाई गई`)
};

const pt_pt2_style_guide_manager_created_toast = /** @type {(inputs: Style_Guide_Manager_Created_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novo guia de estilo criado`)
};

/**
* | output |
* | --- |
* | "New style guide created" |
*
* @param {Style_Guide_Manager_Created_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_created_toast = /** @type {((inputs?: Style_Guide_Manager_Created_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Created_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_style_guide_manager_created_toast(inputs)
	if (locale === "de") return de_style_guide_manager_created_toast(inputs)
	if (locale === "it") return it_style_guide_manager_created_toast(inputs)
	if (locale === "ru") return ru_style_guide_manager_created_toast(inputs)
	if (locale === "es") return es_style_guide_manager_created_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_style_guide_manager_created_toast(inputs)
	if (locale === "ja") return ja_style_guide_manager_created_toast(inputs)
	if (locale === "hi") return hi_style_guide_manager_created_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_style_guide_manager_created_toast(inputs)
	return en_style_guide_manager_created_toast(inputs)
});